import Badge from '../badges/Badge'

type Props = {
    live?: number | null
    draft?: number | null
}

/**
 * The live version of a classifier, plus a draft chip when one is pending above
 * it. There is no per-profile version drift — going live updates every profile at
 * once — so those are the only two states worth surfacing.
 */
export default function VersionCell({ live, draft }: Props) {
    return (
        <div className="flex items-center gap-1.5 tabular-nums">
            {live != null ? (
                <span className="inline-flex items-center gap-1 text-ink-700">
                    <span className="h-1.5 w-1.5 rounded-full bg-safe" aria-hidden="true" />v{live}
                </span>
            ) : (
                <span className="text-ink-400">No live version</span>
            )}
            {draft != null && (
                <Badge tone="outline" size="tiny" caps>
                    Draft v{draft}
                </Badge>
            )}
        </div>
    )
}
